import React, { FC, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Menu.css';
import { colors } from 'saur_ui_library/src/Theme';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Title from '../../assets/Menu/titleDiag.svg';
import Drop from '../../assets/Menu/drop.svg';
import ArrowDown from '../../assets/Menu/arrowDown.svg';
import ArrowUp from '../../assets/Menu/arrowUp.svg';
import Deconnexion from '../../assets/Menu/logout.svg';
import { createGlobalStyle } from 'styled-components';
import ContractPopup from '../contractsList/ContractPopup';
import ToolsMenu from './ToolsMenu';
import { useDispatch, useSelector } from 'react-redux';
import { initialState } from '../../redux/reducers/contracts';
import { SET_CONTRACT_CLOSE } from '../../redux/actionType';
import WatchJobs from '../common/WatchJobs';
import 'primeicons/primeicons.css';
import { LocalStorage } from '../../utils/localStorage';
import IconComponent from '../common/component/IconComponent';
import { closeContract } from '../../utils/helpers/observer';
import ModulesMenu from './ModulesMenu';
import { useKeycloak } from '@react-keycloak/web';
import SaurIcon from '../common/Icon/SaurIcon';
import { HttpArcgis, Https, HttpsZip } from '../../utils/http';
import { useNavigate } from 'react-router-dom';
import ResetStyleComponent from '../cssSaur/resetStyleComponent';

// Header component
const Menu = () => {
  const roles = LocalStorage.userRole.get();
  const sessionCode = window.sessionStorage.getItem('contractCode') || '';
  const dispatch = useDispatch();
  const contractClose = useSelector(
    (state: typeof initialState) => state?.toClose
  );
  const [showPopup, setShowPopup] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [containerModulesMaxHeight, setContainerModulesMaxHeight] =
    useState('550px');

  const { keycloak, } = useKeycloak();
  const [, setSessionAvailable] = useState(true);
  const navigate = useNavigate();
  
  closeContract.getStatus().subscribe((b: any) => {
    setShowPopup(b);
  });

  Https.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        disconnect();
      }
      return Promise.reject(error);
  });

  HttpsZip.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        disconnect();
      }
      return Promise.reject(error);
  });

  HttpArcgis.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        disconnect();
      }
      return Promise.reject(error);
  });
  
  // to logout user
  const disconnect = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/');
    keycloak
        .logout()
        .catch((e: any) => {
            console.error('keycloak_logout Failed', e)
        })
  }

  useEffect(() => {
      if (sessionCode !== '') {
          setSessionAvailable(false)
      }
  }, [sessionCode]);

  useEffect(() => {
    // if no contract already chosen
    if (sessionCode === '') {
      setShowPopup(true);
    }
  }, [sessionCode]);

  // render of breakline
  const breakLine = () => {
    return (
      <hr
        style={{
          backgroundColor: '#1156B2',
          border: 'none',
          outline: 'none',
          width: '205px',
          height: '2px',
          margin: '2px 0 2px 30px',
        }}
      />
    );
  };

  const divStylesMainIcons = {
    display: 'inline-flex',
    alignSelf: 'center',
    width: '4vh',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'white'
  };

  // Render the component
  return (
    <>
      {/* Popup of contracts to choose */}
      {showPopup === true && <ContractPopup />}
      {/* Nav bar */}
      <Container className='sds-reset-style color-nav' automatedTestId='header'>
        <ResetStyleComponent />
        <Styles />
        {/* Logo saur */}
        <Container className='logo' style={{ marginLeft: '10px' }}>
          <a
            href='/#/DO'
            id='home'
            onClick={() => {
              window.localStorage.setItem('type', 'do');
            }}
            style={{ width: '90%'}}
          >
            <SaurIcon content='login' color={colors.white}></SaurIcon>
          </a>
          <IconComponent
            icon={Title}
            divStyles={{
              marginLeft: '20px',
              width: 'fit-content',
            }}
            imgStyles={{
              width: '70%',
            }}
          />
        </Container>
        {/* WatchJobs */}
        <Container>
          <WatchJobs />
        </Container>
        {/* Contract number */}
        <Container
          style={{ display: 'block', padding: '10px', marginLeft: '10px' }}
        >
          <IconComponent
            icon={Drop}
            divStyles={divStylesMainIcons}
            title={sessionCode}
            event={() => {
              setShowPopup(true);
            }}
          />
        </Container>
        {/* Tools menu */}
        {!roles?.includes('collectivity-consult') && (
          <Container
            style={{
              display: 'block',
              padding: '10px',
              marginLeft: '20px',
              color: 'white',
            }}
          >
            <IconComponent
              icon={toggle === true ? ArrowUp : ArrowDown}
              divStyles={divStylesMainIcons}
              imgStyles={{
                marginRight: '10px',
                marginLeft: '5px',
                marginBottom: '5px',
              }}
              show={!roles?.includes('diagperm-consult') ? true : false}
              titleStyles={{
                marginBottom: '5px',
              }}
              title={'Outils'}
              event={() => {
                if (!contractClose) {
                  dispatch({ type: SET_CONTRACT_CLOSE, payload: true });
                  setContainerModulesMaxHeight('300px');
                  setToggle(true);
                } else {
                  dispatch({ type: SET_CONTRACT_CLOSE, payload: false });
                  setContainerModulesMaxHeight('550px');
                  setToggle(false);
                }
              }}
            />
            <Container
              className={`${
                contractClose ? 'menu-contract' : 'hide-menu-contract'
              }`}
            >
              <ToolsMenu />
            </Container>
          </Container>
        )}
        {breakLine()}
        {/* Modules */}
        <Container
          style={{
            display: 'block',
            padding: '10px',
            maxHeight: containerModulesMaxHeight,
            overflowY: 'auto',
            marginLeft: '20px',
          }}
        >
          <ModulesMenu
            upperBlock={[
              {
                id: 1,
                label: 'DO-TP',
                value: '/DO',
                automatedTestId: 'menu-dotp',
                show: true,
              },
              {
                id: 2,
                label: 'PR-MR',
                value: '/PR',
                automatedTestId: 'menu-prmr',
                show: true,
              },
            ]}
            downBlock={[
              {
                id: 3,
                label: 'ECP',
                value: '/ECP',
                automatedTestId: 'menu-ecp',
                show: true,
              },
              {
                id: 4,
                label: 'H2S',
                value: '/IndicatorBoonLister',
                automatedTestId: 'menu-h2s',
                show: true,
              },
              {
                id: 5,
                label: 'INDUS',
                value: '/Indus',
                automatedTestId: 'menu-indus',
                show: true,
              },
              {
                id: 6,
                label: 'HYDRO',
                value: '/Hydro',
                automatedTestId: 'menu-hydro',
                show: true,
              },
              {
                id: 7,
                label: 'MILIEU',
                value: '/MilieuSensibility',
                automatedTestId: 'menu-milieu',
                show: true,
              },
              {
                id: 8,
                label: 'PLUIE',
                value: '/Pluie',
                automatedTestId: 'menu-pluie',
                show: true,
              },
            ]}
            collectionPoolBlock={[
              {
                id: 9,
                label: 'Bassin de collecte',
                value: '/CollectionPool',
                automatedTestId: 'menu-collectionPool',
                show: true,
              },
            ]}
            adminBlock={[
              {
                id: 10,
                label: 'Administration',
                value: '/Administration',
                automatedTestId: 'menu-admin',
                show: roles?.includes('diagperm-admin') ? true : false,
              },
              {
                id: 11,
                label: 'Supervision',
                value: '/Monitoring',
                automatedTestId: 'menu-monitor',
                show: roles?.includes('diagperm-admin') ? true : false,
              },
            ]}
          />
        </Container>
        {breakLine()}
        {/* Deconnexion */}
        <IconComponent
          icon={Deconnexion}
          divStyles={{
            display: 'inline-flex',
            paddingLeft: '20px',
            alignItems: 'center',
            cursor: 'pointer',
            color: 'white',
          }}
          title={'Se déconnecter'}
          event={(c: any) => {
            if (c) {
              disconnect();
            }
          }}
        />
      </Container>
    </>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  font-family: 'Montserrat', sans-serif;
  .ReactTable .rt-noData {
    z-index: 0;
  }
.color-nav{
  .pi{
    font-family: 'primeicons';
    color: white;    
  }
  .header-content{
    flex-direction: row;
    justify-content: space-between;   
    }
  
  img#img-logo.header-logo{
    width: 13.6vw;
    margin-top: 0.9vw;
    margin-left: 1vw;
  }
  .p-inputtext.p-component{
    width: 30vw;

}
  .import-export {
    margin-top: 1.4vw;
  } 
   img#img-import.header-import, .ecp-modal {
    width:2.8vw;
    margin-left:20px;

  }
  #contract-code {
      margin-right:10px;
      margin-right: 1rem;
      //ecran M 1024px
      @media(min-width: 64em){
        font-size:14px;
        margin-top: 1.75vw;  
      }
      // ecran L 1366px
      @media(min-width: 85.375em){
        font-size:18px;
        margin-top: 2.1vw;
      }
      // ecran XL 1900px
      @media(min-width: 183.25em){
        font-size:19px;
        margin-top: 2.3vw
      }  
      border: none;
      text-decoration: underline;
      letter-spacing: 0.5px;
      color: #ffffff;
    } 
    .hide-menu-contract{
      display:none;
    }
    .menu-contract{
    width: fit-content;
    }
    .last-divider{
      margin-left: 4vw;
      border-left: 0.25vw solid white;
      border-radius: 18%;
      height: 1.56vw;
      margin-top: 0.5vw;
      position: absolute;
    }
}
}
 
`;

export default Menu;
